var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{ref:"audio-ctrl",staticClass:"lazy-audio"},_vm._l((_vm.sources),function(source,idx){return _c('source',{key:idx,attrs:{"data-src":source}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }